import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { selectDielectricConstant } from './DielectricConstant.data';
import { StyleDropdown } from './DielectricConstant.styled';
import { StyledLabelTab } from '../FailureModeSection/FailureModeSection.styled';

const DielectricConstantSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly, userRole } = props;
    const dropdownInput = (field) => field.isDropdown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                labelWidth={field.labelWidth}
                width={field.width}
                height={field.height}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                readOnly={isFormReadOnly || field.readOnly}
                direction={field.direction}
                textAlign={field.textAlign}
                borderTop={field.borderTop}
                borderRight={field.borderRight}
                inputTextAlign={field.inputTextAlign}
            />
        </StyleDropdown>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                isCalculated={field.isCalculated}
                isCalculatedNew={field.isCalculatedNew}
                handleChange={changeHandler}
                readOnly={field.readOnly || isFormReadOnly}
                labelWidth={field.labelWidth}
                width={field.width}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                direction={field.direction}
                padding={field.padding}
                type={field.type}
                marginBottom={field.marginBotom}
                maxLength={field.maxLength}
                borderRight={field.borderRight}
                borderTop={field.borderTop}
                borderBottom={field.borderBottom}
                textAlign={field.textAlign}
                userRole={userRole}
                isDisabled={field.isDisabled}
                height={field.height}
                hasDPSError={field.hasDPSError}
                marginTop={field.marginTop}
            />
        );
    return (
        <div>
            {
                selectDielectricConstant(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabelTab
                                            formName={formName}
                                        >
                                            <StyledLabel
                                                id={field.key}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                color={field.color}
                                                fontSize={field.fontSize}
                                                fontStyle={field.fontStyle}
                                                marginTop={field.marginTop}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        </StyledLabelTab>
                                    )
                                    : dropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </div>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DielectricConstantSection);

DielectricConstantSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
